// extracted by mini-css-extract-plugin
export default {"header_main_container":"Header_header_main_container__A7Qax","header_container":"Header_header_container__q2kGc","image":"Header_image__-+pU0"};